import { useState, useEffect } from 'react';
import { FloppyDisk, Check } from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import api from '@/lib/api';

const CONTENT_FIELDS = [
  { key: 'company_name', label: 'Company Name', type: 'text' },
  { key: 'company_tagline', label: 'Tagline', type: 'text' },
  { key: 'company_phone', label: 'Phone Number', type: 'text' },
  { key: 'company_email', label: 'Email', type: 'text' },
  { key: 'company_address', label: 'HQ Address', type: 'textarea' },
  { key: 'hero_title', label: 'Homepage Hero Title', type: 'text' },
  { key: 'hero_subtitle', label: 'Homepage Hero Subtitle', type: 'textarea' },
];

export default function CMSContentPanel({ token }) {
  const [content, setContent] = useState({});
  const [saving, setSaving] = useState({});
  const [saved, setSaved] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/cms/content').then(res => setContent(res.data)).catch(console.error).finally(() => setLoading(false));
  }, []);

  const handleSave = async (key) => {
    setSaving(prev => ({ ...prev, [key]: true }));
    try {
      await api.put(`/admin/cms/content?token=${token}`, { key, value: content[key] || '' });
      setSaved(prev => ({ ...prev, [key]: true }));
      setTimeout(() => setSaved(prev => ({ ...prev, [key]: false })), 2000);
    } catch (e) { alert('Failed to save'); }
    finally { setSaving(prev => ({ ...prev, [key]: false })); }
  };

  if (loading) return <div className="text-center py-12 text-[#4A5568]">Loading...</div>;

  return (
    <div className="space-y-4" data-testid="cms-content-panel">
      <div className="bg-white border border-slate-200 p-6">
        <h3 className="text-lg font-bold text-[#0A1F3D] mb-6">Site Content Settings</h3>
        <div className="space-y-5">
          {CONTENT_FIELDS.map(field => (
            <div key={field.key} className="flex flex-col md:flex-row md:items-start gap-3">
              <label className="text-sm font-medium text-[#0A1F3D] w-48 flex-shrink-0 pt-2">{field.label}</label>
              <div className="flex-1">
                {field.type === 'textarea' ? (
                  <Textarea
                    data-testid={`content-${field.key}`}
                    value={content[field.key] || ''}
                    onChange={(e) => setContent({ ...content, [field.key]: e.target.value })}
                    rows={2}
                    className="rounded-none"
                  />
                ) : (
                  <Input
                    data-testid={`content-${field.key}`}
                    value={content[field.key] || ''}
                    onChange={(e) => setContent({ ...content, [field.key]: e.target.value })}
                    className="rounded-none"
                  />
                )}
              </div>
              <Button
                data-testid={`save-${field.key}`}
                onClick={() => handleSave(field.key)}
                disabled={saving[field.key]}
                className={`rounded-none flex-shrink-0 ${saved[field.key] ? 'bg-green-600 text-white' : 'bg-[#0A1F3D] text-white hover:bg-[#0f294d]'}`}
              >
                {saved[field.key] ? <><Check size={14} /> Saved</> : saving[field.key] ? 'Saving...' : <><FloppyDisk size={14} /> Save</>}
              </Button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
